import { z } from "zod";

/**
 * Eventos de dominio (fuente única — C2). El engine deriva su tipo de acá;
 * el save y la telemetría los serializan; el simulador de F2 los emite.
 */

export const GameEventV0 = z.discriminatedUnion("t", [
  z.object({ t: z.literal("artifactViewed"), id: z.string(), at: z.number() }),
  z.object({ t: z.literal("evidencePinned"), id: z.string(), at: z.number() }),
  z.object({ t: z.literal("notePinned"), text: z.string(), at: z.number() }),
  z.object({ t: z.literal("boardLinked"), a: z.string(), b: z.string(), at: z.number() }),
  z.object({ t: z.literal("termSearched"), app: z.string(), q: z.string(), at: z.number() }),
  z.object({
    t: z.literal("accusationAttempted"),
    answers: z.record(z.string(), z.string()),
    at: z.number(),
  }),
  // ── F1 ──
  /** Verbo Solicitar de los módulos (F1-T08); el reloj lo cuenta como acción */
  z.object({
    t: z.literal("requestSubmitted"),
    formId: z.string(),
    fields: z.record(z.string(), z.string()).default({}),
    at: z.number(),
  }),
  /** Intento sobre un hito del expediente (F1-T04) */
  z.object({
    t: z.literal("milestoneAttempted"),
    milestoneId: z.string(),
    answers: z.record(z.string(), z.string()),
    at: z.number(),
  }),
  /** Cita: texto seleccionado dentro de un artefacto, fijado al corcho (F1-T06, C12) */
  z.object({
    t: z.literal("quotePinned"),
    artifactId: z.string(),
    quote: z.string().min(1),
    at: z.number(),
  }),
  /** Pedido de hint a M. (F1-T05); el costo lo aplica el score */
  z.object({
    t: z.literal("hintRequested"),
    level: z.number(),
    at: z.number(),
  }),
]);

export type GameEventData = z.infer<typeof GameEventV0>;
